import { IAuthService } from '../services/IAuthService'
import { IWorkspaceService } from '../services/IWorkspaceService'
import { IRoomService } from '../services/IRoomService'
import { AuthService } from '../services/AuthService'
import { WorkspaceService } from '../services/WorkspaceService'
import { Back4AppAuthRepository } from '../repositories/Back4AppAuthRepository'
import { Back4AppWorkspaceRepository } from '../repositories/Back4AppWorkspaceRepository'

export class ServiceFactory {
  private static instance: ServiceFactory
  private authService: IAuthService | null = null
  private workspaceService: IWorkspaceService | null = null
  private roomService: IRoomService | null = null

  private constructor() {}

  static getInstance(): ServiceFactory {
    if (!ServiceFactory.instance) {
      ServiceFactory.instance = new ServiceFactory()
    }
    return ServiceFactory.instance
  }

  getAuthService(): IAuthService {
    if (!this.authService) {
      const authRepository = new Back4AppAuthRepository()
      this.authService = new AuthService(authRepository)
    }
    return this.authService
  }

  getWorkspaceService(): IWorkspaceService {
    if (!this.workspaceService) {
      const workspaceRepository = new Back4AppWorkspaceRepository()
      this.workspaceService = new WorkspaceService(workspaceRepository)
    }
    return this.workspaceService
  }

  getRoomService(): IRoomService {
    if (!this.roomService) {
      // TODO: Implement RoomService and RoomRepository
      throw new Error('RoomService not yet implemented')
    }
    return this.roomService
  }

  // Method to reset services (useful for testing)
  reset(): void {
    this.authService = null
    this.workspaceService = null
    this.roomService = null
  }
} 